var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.domainSettings)?_c('div',{staticClass:"protal-footer d-flex justify-between align-center py-40",domProps:{"innerHTML":_vm._s(_vm.domainSettings.portalCopyright)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }